
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ExpenseDetailGrid extends Serenity.EntityGrid<ExpenseDetailRow, any> {
        protected getColumnsKey() { return 'Finance.ExpenseDetail'; }
        protected getDialogType() { return ExpenseDetailDialog; }
        protected getIdProperty() { return ExpenseDetailRow.idProperty; }
        protected getInsertPermission() { return ExpenseDetailRow.insertPermission; }
        protected getLocalTextPrefix() { return ExpenseDetailRow.localTextPrefix; }
        protected getService() { return ExpenseDetailService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}